// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".compare-text-content pre .c-added{--tw-text-opacity:1;color:rgb(29 136 32/var(--tw-text-opacity))}.compare-text-content pre .c-removed{--tw-text-opacity:1;color:rgb(209 26 50/var(--tw-text-opacity))}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
